module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_1000_2000.31b51ad5.png";